export const CHANGE_PASSWORD = 'change-password';
export const NOT_AUTHORIZED = 'not-authorized';

export const routes = Object.freeze({

  dashboard: {
    root: '/',
  },

  energyCommunity: {
    root: '/energy-community',
  },

  changePassword: {
    root: `/${CHANGE_PASSWORD}`,
  },

  notAuthorized: {
    root: `/${NOT_AUTHORIZED}`,
  },

});

export default {
  CHANGE_PASSWORD,
  NOT_AUTHORIZED,
};
